
import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancel-request',
  templateUrl: './cancel-request.component.html',
  styleUrls: ['./cancel-request.component.scss'],
})
export class CancelRequestComponent implements OnInit {
 
  constructor(
    private modalCtl: ModalController
  ) { 
  }

  ngOnInit() {}

  dismiss(){
    this.modalCtl.dismiss();
  }

}
